import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useMemo, useState } from "react"
import { FaEdit, FaEye, FaPlus, FaTrashAlt } from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import { Button, Card, CardBody, Input, Table } from "reactstrap"
import Swal from "sweetalert2"
import HolidayModal from "./HolidayModal"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Loader from "components/Loader/Loader"
import moment from "moment"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

const Holiday = () => {
  document.title = "Holiday | Vintage Infra Equipment Sol PVT LTD"

  const [pageSize, setPageSize] = useState(10)
  const [searchString, setSearchString] = useState("")

  const [loading, setLoading] = useState(false)

  const [holidayData, setHolidayData] = useState([])

  // pagination
  const [currentPage, setCurrentPage] = useState(1)

  const filteredData = useMemo(() => {
    return holidayData.filter(item =>
      item.reason.toLowerCase().includes(searchString.toLowerCase())
    )
  }, [holidayData, searchString])

  const totalPages = Math.ceil(filteredData.length / pageSize)
  const start = (currentPage - 1) * pageSize

  const paginatedData = useMemo(() => {
    return filteredData.slice(start, start + pageSize)
  }, [filteredData, start, pageSize])

  // modal
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedHoliday, setSelectedHoliday] = useState({})
  const [viewOnly, setViewOnly] = useState(false)

  useEffect(() => {
    getHolidays()
  }, [])

  async function getHolidays() {
    const APIdata = await fetchData(setLoading, "holiday")
    if (APIdata?.success) {
      setHolidayData(APIdata?.data)
    }
  }

  const handleSubmit = async () => {
    if (selectedHoliday.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "holiday",
        selectedHoliday?.id,
        {
          date: selectedHoliday?.date,
          reason: selectedHoliday?.reason,
        }
      )

      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Holiday Updated Successfully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        getHolidays()
      } else {
        Swal.fire({
          title: "Error Updating Holiday.",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "holiday", {
        date: selectedHoliday?.date,
        reason: selectedHoliday?.reason,
      })

      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Holiday Added Successfully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        getHolidays()
      } else {
        Swal.fire({
          title: "Error Adding Holiday.",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
    setModalOpen(false)
  }

  const handleDelete = id => {
    Swal.fire({
      title: "Delete Holiday?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchDeleteData(setLoading, "holiday", id)

        if (APIdata?.data?.success) {
          Swal.fire({
            title: "Holiday Deleted Successfully.",
            text: APIdata?.data?.message,
            icon: "success",
          })
          getHolidays()
        } else {
          Swal.fire({
            title: "Error deleting Holiday.",
            text: APIdata?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  const { checkAccess } = usePermissionData()

  return (
    <PermittedComponent isAccess={checkAccess(9, "view")}>
      <div className="page-content">
        {loading && <Loader />}
        <Breadcrumb title="Leave Management" breadcrumbItem="Holiday" />

        <Card>
          <CardBody>
            {/* Top bar */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex gap-3">
                <Input
                  type="select"
                  value={pageSize}
                  onChange={e => setPageSize(Number(e.target.value))}
                  className="rounded-4 w-auto"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Input>

                <Input
                  placeholder="Search holiday"
                  value={searchString}
                  onChange={e => setSearchString(e.target.value)}
                  className="rounded-4"
                />
              </div>
              {checkAccess(9, "add") && (
                <Button
                  className="btn-blue rounded-4"
                  onClick={() => {
                    setSelectedHoliday({})
                    setViewOnly(false)
                    setModalOpen(true)
                  }}
                >
                  <FaPlus className="me-2" />
                  Holiday
                </Button>
              )}
            </div>

            {/* Table */}
            <Table bordered responsive>
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Reason</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No holidays found
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{start + index + 1}</td>
                      <td>{moment(item.date).format("DD-MM-YYYY")}</td>
                      <td>{item.reason}</td>
                      <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                      <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        <Button
                          className="bg-info text-white border-0 shadow-none me-2"
                          onClick={() => {
                            setSelectedHoliday(item)
                            setViewOnly(true)
                            setModalOpen(true)
                          }}
                        >
                          <FaEye size={16} />
                        </Button>
                        {/* {checkAccess(9, "edit") && (
                          <Button
                            className="bg-success text-white border-0 shadow-none mx-2"
                            onClick={() => {
                              setSelectedHoliday(item)
                              setViewOnly(false)
                              setModalOpen(true)
                            }}
                          >
                            <FaEdit size={16} />
                          </Button>
                        )} */}
                        {checkAccess(9, "delete") && (
                          <Button
                            className="bg-danger text-white border-0 shadow-none"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FaTrashAlt size={16} />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            {/* ================= Pagination ================= */}
            <nav className="d-flex justify-content-between mt-3">
              <h6>
                Showing {filteredData.length === 0 ? 0 : start + 1} to{" "}
                {Math.min(start + pageSize, filteredData.length)} of{" "}
                {filteredData.length} entries
              </h6>

              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      setCurrentPage(prev => Math.max(prev - 1, 1))
                    }
                  >
                    Previous
                  </button>
                </li>

                {[...Array(totalPages)].map((_, i) => {
                  const pageNum = i + 1
                  return (
                    <li
                      key={pageNum}
                      className={`page-item ${
                        pageNum === currentPage ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(pageNum)}
                      >
                        {pageNum}
                      </button>
                    </li>
                  )
                })}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      setCurrentPage(prev => Math.min(prev + 1, totalPages))
                    }
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </CardBody>
        </Card>

        <HolidayModal
          open={modalOpen}
          toggle={() => setModalOpen(false)}
          selectedHoliday={selectedHoliday}
          setSelectedHoliday={setSelectedHoliday}
          viewOnly={viewOnly}
          onSubmit={handleSubmit}
        />
      </div>
    </PermittedComponent>
  )
}

export default Holiday
